import {
  createDeleteListFormData,
  createCreateListFormData,
  createAddItemFormData,
  createUpdateListFormData,
  listActionStandard,
} from './helper';
import { messageBoxSuccess, messageBoxError } from '../components/message-box';

class PopupEditGroup {
  public editGroupPopup: HTMLElement;

  public editButtons: NodeListOf<HTMLElement>;

  public actionButtons: NodeListOf<HTMLElement>;

  public formEditGroup: HTMLFormElement;

  public confirmPopup: HTMLElement;

  public editPopupWasOpen: boolean = false;

  public listId: string;

  public listTitle: string;

  public wishlistContent: any;

  constructor(wishlistContent: any) {
    this.wishlistContent = wishlistContent;
  }

  saveDetails(e: Event) {
    const target = e.currentTarget as HTMLElement;

    this.listId = target.dataset.listId as string;
    this.listTitle = target.dataset.listTitle as string;

    (this.formEditGroup.querySelector('input[name="listId"]') as HTMLFormElement).value = this.listId;
    (this.formEditGroup.querySelector('input[name="title"]') as HTMLFormElement).value = this.listTitle;

    this.editGroupPopup.querySelectorAll('.a-wishlist-link').forEach((link) => (link as HTMLElement).dataset.preselected = this.listId);

    this.editPopupWasOpen = true;
  }

  async handleActionButton(e: Event) {
    const target = e.currentTarget as HTMLElement;

    switch(target.dataset.action) {
      case 'clone':
        const language: string | null = document.documentElement.lang ?? '';

        const requests = [];

        try {
          const res = await listActionStandard(createCreateListFormData(`${this.listTitle} - ${language === 'en-US' ? 'Copy' : 'Kopie'}`));
          const listToClone = this.wishlistContent.filter((list: any) => list.list_id == this.listId)[0];

          listToClone.items?.forEach((item: any) => {
            const newItemFormData = createAddItemFormData(item.element_id, res.id);
            newItemFormData.append('fields[plaintext_title_1]', item.quantity);
            newItemFormData.append('fields[plaintext_title_2]', item.hide_price ? '1' : '0');

            requests.push(listActionStandard(newItemFormData));
          });

          let newSections: Array<any> = [];

          for (const section of listToClone.sections) {
            const newListFormData = createCreateListFormData(`${section.title} - ${language === 'en-US' ? 'Copy' : 'Kopie'}`, 'wishlist_section');
            newListFormData.append('fields[json_relation]', res.id);

            const sectionRes = await listActionStandard(newListFormData);

            newSections.push(sectionRes.id);

            for (const item of section.items) {
              const newItemFormData = createAddItemFormData(item.element_id, sectionRes.id);
              newItemFormData.append('fields[plaintext_title_1]', item.quantity);
              newItemFormData.append('fields[plaintext_title_2]', item.hide_price ? '1' : '0');

              requests.push(listActionStandard(newItemFormData));
            }
          }

          const updateParentListFormData = createUpdateListFormData(res.id);
          updateParentListFormData.append('fields[json_relation]', JSON.stringify({children: newSections}));

          requests.push(listActionStandard(updateParentListFormData));

          await Promise.all(requests);

          const url = new URL(window.location as unknown as string);

          messageBoxSuccess({
            contentDe: `Gruppe wurde erfolgreich dupliziert und als „${this.listTitle} - Kopie“ angelegt.`,
            contentEn: `Successfully cloned group as „${this.listTitle} - Copy“.`,
          });

          url.searchParams.set('group', res.id);
          window.history.pushState({}, '', url as unknown as string);
          setTimeout(() => {window.location.reload()}, 200);
        } catch (e) {
          console.error(e);

          messageBoxError({
            contentDe: 'Es ist ein Fehler aufgetreten. Gruppe konnte nicht dupliziert werden.',
            contentEn: 'An error appeared. Could not clone group.',
          });
        }
        break;
      case 'delete':
        this.editGroupPopup.classList.remove('m-popup--is-active');
        this.confirmPopup.classList.add('m-popup--is-active');

        const confirmDeleteButton = this.confirmPopup.querySelector('.a-button:last-child') as HTMLLinkElement;

        confirmDeleteButton.addEventListener('click', async (e: Event) => {
          e.preventDefault();

          const requests = [];

          try {
            const listToDelete = this.wishlistContent.filter((list: any) => list.list_id == this.listId)[0];

            for (const section of listToDelete.sections) {
              requests.push(listActionStandard(createDeleteListFormData(section.section_id)));
            }

            requests.push(listActionStandard(createDeleteListFormData(this.listId)));

            await Promise.all(requests);

            const url = new URL(window.location as unknown as string);

            messageBoxSuccess({
              contentDe: 'Gruppe wurde erfolgreich gelöscht.',
              contentEn: 'Successfully deleted group.',
            });

            url.searchParams.delete('group');
            window.history.pushState({}, '', url as unknown as string);
            setTimeout(() => {window.location.reload()}, 200);
          } catch (e) {
            console.error(e);

            messageBoxError({
              contentDe: 'Es ist ein Fehler aufgetreten. Gruppe konnte nicht gelöscht werden',
              contentEn: 'An error appeared. Could not delete group.',
            });
          }
        });
        break;
      default:
    }
  }

  async handleSubmit(e: Event) {
    e.preventDefault();

    try {
      await listActionStandard(new FormData(this.formEditGroup));

      messageBoxSuccess({
        contentDe: 'Gruppe wurde erfolgreich gespeichert.',
        contentEn: 'Successfully saved group.',
      });

      setTimeout(() => {window.location.reload()}, 200);
    } catch (e) {
      console.error(e);

      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten. Gruppe konnte nicht gespeichert werden.',
        contentEn: 'An error appeared. Could not save group.',
      });
    }
  }

  bindings() {
    if (this.editButtons) {
      this.editButtons.forEach((button) => {
        button.addEventListener('click', this.saveDetails.bind(this));
      });
    }

    if (this.actionButtons) {
      this.actionButtons.forEach((button) => {
        button.addEventListener('click', this.handleActionButton.bind(this));
      });
    }

    if (this.formEditGroup) {
      this.formEditGroup.addEventListener('submit', this.handleSubmit.bind(this));
    }

    if (this.confirmPopup) {
      this.confirmPopup.querySelector('.a-button:first-child')?.addEventListener('click', () => {
        this.confirmPopup.classList.remove('m-popup--is-active');

        if (this.editPopupWasOpen) {
          this.editGroupPopup.classList.add('m-popup--is-active');
        }
      });
    }
  }

  cache() {
    this.editGroupPopup = document.getElementById('wishlist-popup-edit-group') as HTMLElement;
    this.confirmPopup = document.querySelector('.m-wishlist-popup.m-confirm-popup') as HTMLElement;
    this.editButtons = document.querySelectorAll('.m-wishlist-group-headline__button-edit, .m-wishlist-group-teaser .m-wishlist-group-teaser__edit');
    this.actionButtons = this.editGroupPopup?.querySelectorAll('.a-wishlist-button');
    this.formEditGroup = this.editGroupPopup?.querySelector('.js-form-rename') as HTMLFormElement;
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default PopupEditGroup;
